<script>
  import { Link } from 'svelte-navigator'
  import { _ } from 'svelte-i18n'

  import fetchO from '../../oauth.js'

  import WorkoutPlanCardWidget from '../../components/WorkoutPlanCardWidget.svelte'

  // Fetch all workout plans of the user
  let fetchWorkoutPlans = (async () => {
    const response = await fetchO('/workout_plans/')
    return await response.json()
  })()
</script>

<div class="d-flex pb-1 align-items-center">
  <div class="me-auto">
    <h3>{$_('workoutplans.list.myworkoutplans')}</h3>
  </div>
  <div>
    <Link
      to="new/"
      class="btn btn-secondary"
      role="button"
      aria-label={$_('workoutplans.list.addnewplan')}
      ><i class="bi bi-plus-square" />
      <span class="d-none d-md-inline"
        >{$_('workoutplans.list.addnewplan')}</span
      ></Link
    >
  </div>
</div>
<div class="row g-3">
  {#await fetchWorkoutPlans}
    <div class="col d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">{$_('generic.loading')}...</span>
      </div>
    </div>
  {:then data}
    {#each data.results as wp (wp.id)}
      <div class="col-sm-12 col-md-6 col-xl-4">
        <WorkoutPlanCardWidget {wp} />
      </div>
    {/each}
  {:catch error}
    <p>An error occurred {error}!</p>
  {/await}
</div>

<svelte:head>
  <title>{$_('workoutplans.list.title')}</title>
</svelte:head>
